import { render } from "./PrimaryButton.vue?vue&type=template&id=4744e9ac&ts=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__